import TaskView from './TaskView';

export default TaskView;
